import "./HeaderSettings.scss";
import "react";

import { ViewPermissions } from "components/ViewPermissions";
import { useBoard, usePermissions } from "providers";

export const HeaderSettings: React.FC = () => {
  const permissions = usePermissions();
  const { boardPermissions } = useBoard();

  const value = { ...permissions, ...boardPermissions };
  return (
    <div className="header-settings mr-4 show-permissions">
      <ViewPermissions item={value} type="Permissions" />
    </div>
  );
};
